module.exports = __webpack_public_path__ + "02_long_grey.5703f244.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_long_grey.png
// module id = xMr8
// module chunks = 0